import { List, SimpleGrid, SimpleGridProps, Text } from "@biblioteksentralen/react";
import { Publication, PublicationListItem, SanityKeyed } from "@libry-content/types";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import { CordataWork } from "@libry-content/integrations";
import ItemPreview from "./ItemPreview";

export type GridItem = CordataWork | SanityKeyed<Publication> | SanityKeyed<PublicationListItem>;
type Props = {
  items?: GridItem[];
  autoFocusIndex?: number;
  headingSize?: "h2" | "h3";
  showPublicationTeaser?: boolean;
} & SimpleGridProps;

const ItemGrid = ({ items, autoFocusIndex, headingSize = "h3", showPublicationTeaser, ...chakraProps }: Props) => {
  const { ts } = useTranslation();
  if (!items) return null;
  return (
    <SimpleGrid as={List} spacing="2rem" width="100%" columns={{ base: 1, md: 2, lg: 3 }} {...chakraProps}>
      {items.map((item, index) => {
        const isWork = itemIsWork(item);
        const key = isWork ? item.id : item._key;
        return (
          <ItemPreview key={key} item={item} headingSize={headingSize} autoFocus={autoFocusIndex === index}>
            {showPublicationTeaser && item && !isWork && item._type == "publicationListItem" && (
              <Text fontSize="sm">{ts(item.contextualTeaser)}</Text>
            )}
          </ItemPreview>
        );
      })}
    </SimpleGrid>
  );
};

export const itemIsWork = (item: GridItem): item is CordataWork => (item as any)?.["work"]?.["type"] === "Work";

export default ItemGrid;
